__turbopack_context__.v({
  "card": "Timeline-module__V0GRYa__card",
  "card__actions": "Timeline-module__V0GRYa__card__actions",
  "card__btn": "Timeline-module__V0GRYa__card__btn",
  "card__button": "Timeline-module__V0GRYa__card__button",
  "card__logo": "Timeline-module__V0GRYa__card__logo",
  "card__media": "Timeline-module__V0GRYa__card__media",
  "card__title": "Timeline-module__V0GRYa__card__title",
  "left__preTitle": "Timeline-module__V0GRYa__left__preTitle",
  "left__title": "Timeline-module__V0GRYa__left__title",
  "right": "Timeline-module__V0GRYa__right",
  "right__preTitle": "Timeline-module__V0GRYa__right__preTitle",
  "timeline": "Timeline-module__V0GRYa__timeline",
});
